import { Box, BoxProps, Grid } from '@mui/material';
import { colors } from 'spw-theme';
import React from 'react';
import styled from 'styled-components';
import {
  Card,
  CardTitle,
} from 'spw-programming-projects/program-summary/components/styles';
import { PercentBar } from 'spw-programming-projects/program-summary/macro-single-page-summary/styles';
import { AlignEndColumn } from 'spw-shared/globalComponents/grid';
import { GridProps } from '@mui/material/Grid';

export const UsfMixColumn = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    height: 100%;
  }
`;

export const CardBoldValue = styled.div`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const CardBoldSmallValue = styled.div<{ warning?: boolean }>`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 4px;
    color: ${(props) => (props?.warning ? colors.red : colors.black)};
  }
`;

export const SmallCard = styled((props: BoxProps & { $tall?: boolean }) => (
  <Card {...props} />
))`
  && {
    height: ${(props) => (props.$tall ? '170px' : 'calc(100% - 36px)')};
  }
`;

export const SmallCardTitle = styled(CardTitle)`
  && {
    margin-bottom: 18px;
  }
`;

export const SmallCardRow = styled(Box)`
  && {
    height: 40px;
    margin-bottom: 4px;
    align-items: center;
  }
`;

export const IconWrapper = styled(Box)`
  && {
    padding: 0px 20px 0px 4px;
  }
`;

export const MeetingSeatRatioRow = styled(
  (props: BoxProps & { $padded?: boolean }) => <Box {...props} />
)`
  && {
    margin-bottom: ${(props) => (props.$padded ? '16px' : '6px')};
  }
`;

export const CirculationTitle = styled.div`
  && {
    width: 111px;
  }
`;

export const PaddedGrid = styled(Grid)`
  && {
    padding: 8px;
  }
`;

export const SpacePercentBar = styled(PercentBar)`
  && {
    height: 16px;
  }
`;

export const SeatMixBox = styled(Box)`
  && {
    &.pr-16 {
      padding-right: 16px;
    }
  }
`;

export const AlignEndColumnRightPadding = styled(AlignEndColumn)`
  && {
    padding-right: 16px;
  }
`;

export const HeaderColumn = styled((props: GridProps) => (
  <Grid item {...props} />
))`
  && {
    padding-bottom: 8px;

    &.border-right {
      border-right: 1px solid ${colors.offWhite};
    }
  }
`;

export const EmptyMessageWrapper = styled(Box)`
  && {
    height: 203px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const FillableDiv = styled.div`
  && {
    display: flex;
    height: 100%;
  }
`;
